import { Trophy, HandHeart, GraduationCap } from "lucide-react";

const OUTROS = [
  {
    icon: Trophy,
    title: "Esporte",
    desc: "O esporte é uma ferramenta de formação de caráter. Aqui, nossos jovens aprendem disciplina, coletividade, respeito, pontualidade e união. Muito além da prática esportiva, formamos pessoas preparadas para a vida, dentro e fora dos campos.",
    color: "#10B981",
  },
  {
    icon: HandHeart,
    title: "Projetos Sociais",
    desc: "Levamos cuidado onde muitas vezes ninguém chega. Através do reforço escolar, distribuição de cestas básicas e programas sociais, alcançamos famílias com atenção, dignidade e presença constante. Cada ação é um gesto de amor que sustenta, fortalece e transforma realidades.",
    color: "#F59E0B",
  },
  {
    icon: GraduationCap,
    title: "Desenvolvimento",
    desc: "Promovemos oportunidades que geram autonomia e futuro. Nossas oficinas de crochê, horta orgânica, corte e costura e design de sobrancelhas desenvolvem habilidades práticas, despertam talentos e ampliam horizontes. Trabalhamos para que cada jovem construa seu próprio caminho com dignidade e propósito.",
    color: "#8B5CF6",
  },
];

export default function OutrosPilares() {
  return (
    <section
      id="outros-pilares"
      data-testid="outros-pilares-section"
      className="pb-24 sm:pb-28 pt-6 bg-white"
    >
      <div className="container-ga">
        <div className="mb-10">
          <div className="pill border-ga-ink/10 text-ga-ink/60 bg-ga-ink/5 mb-4" data-testid="outros-pilares-pill">
            Outras frentes
          </div>
          <h2 className="font-display font-bold text-2xl sm:text-3xl text-ga-ink">
            Complementando o cuidado com oportunidades reais de transformação.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {OUTROS.map((p) => (
            <article
              key={p.title}
              data-testid={`outro-pilar-${p.title.toLowerCase()}`}
              className="group p-6 rounded-3xl bg-background border border-border hover:border-ga-ink/30 transition-colors"
            >
              <div
                className="w-12 h-12 rounded-2xl flex items-center justify-center text-white mb-4"
                style={{ background: p.color }}
              >
                <p.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-lg text-ga-ink">{p.title}</h3>
              <p className="mt-2 text-sm text-ga-ink/65 leading-relaxed">{p.desc}</p>
            </article>
          ))}
        </div>

        <div
          data-testid="outros-pilares-frase-impacto"
          className="mt-10 rounded-3xl border-2 border-ga-amber/40 bg-ga-amber/5 px-6 py-6 sm:px-8 sm:py-7 flex items-center gap-4"
        >
          <span
            aria-hidden="true"
            className="font-display font-black text-5xl sm:text-6xl leading-none text-ga-amber/70 select-none"
          >
            “
          </span>
          <p className="font-display font-bold text-xl sm:text-2xl text-ga-ink leading-snug tracking-tight">
            Formamos caráter e preparamos pessoas para a vida.
          </p>
        </div>
      </div>
    </section>
  );
}
